// Get the current URL
var currentURL = window.location.href;

// console.log(currentURL);

// Define the mapping of old policy URLs to new URLs
var redirectMap = {
  "https://wkleinberg.com/policies/refund-policy":
    "https://wkleinberg.com/pages/faqs",
  "https://wkleinberg.com/policies/shipping-policy":
    "https://wkleinberg.com/pages/faqs",
  "https://wkleinberg.com/policies/contact":
    "https://wkleinberg.com/pages/contact",
};

// console.log(currentURL in redirectMap);

// Check if the current URL exists in the redirectMap
if (currentURL in redirectMap) {
  // Redirect to the corresponding new URL
  window.location.href = redirectMap[currentURL];
}
